import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

import WaeButton from '../../../components/Button';
import { BLACK, PRIMARY_PURPLE } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

const CreatePageHeader = ({ isCreateDisabled = false, onBack, onCreate }) => {
  const backLabel = LanguageConverterV2('positionTemplate.create.header.back');
  const title = LanguageConverterV2('positionTemplate.create.header.title');
  const subtitle = LanguageConverterV2('positionTemplate.create.header.subtitle');
  const createLabel = LanguageConverterV2('positionTemplate.create.header.create');

  return (
    <Box
      data-testid="position-template-create-header"
      sx={{
        alignItems: 'center',
        backgroundColor: BLACK[0],
        borderBottom: `1px solid ${BLACK[30]}`,
        display: 'flex',
        gap: '24px',
        justifyContent: 'space-between',
        padding: '12px 24px',
      }}
    >
      <Box sx={{ alignItems: 'center', display: 'flex', gap: '24px', minWidth: 0 }}>
        <ButtonBase
          onClick={onBack}
          sx={{
            alignItems: 'center',
            borderRadius: '4px',
            color: BLACK[70],
            display: 'flex',
            flexShrink: 0,
            gap: '8px',
            padding: '4px',
            '&:hover': { color: PRIMARY_PURPLE[70] },
          }}
        >
          <ArrowCircleLeftOutlinedIcon sx={{ fontSize: '20px' }} />
          <Typography sx={{ fontFamily: PRIMARY_FONT[500], fontSize: '14px' }}>
            {backLabel}
          </Typography>
        </ButtonBase>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            component="h1"
            sx={{
              color: BLACK[100],
              fontFamily: PRIMARY_FONT[700],
              fontSize: '20px',
              lineHeight: '28px',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: BLACK[70],
              fontFamily: PRIMARY_FONT[400],
              fontSize: '13px',
              lineHeight: '18px',
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexShrink: 0, gap: '8px' }}>
        <WaeButton
          dataTestId="position-template-create"
          disabled={isCreateDisabled}
          onClick={onCreate}
          text={createLabel}
        />
      </Box>
    </Box>
  );
};

CreatePageHeader.propTypes = {
  isCreateDisabled: PropTypes.bool,
  onBack: PropTypes.func.isRequired,
  onCreate: PropTypes.func,
};

export default CreatePageHeader;
